import React, { useState, useRef, useEffect } from "react";
import { useAuth } from "../context/AuthContext";

const UserMenu = ({ isDarkMode }) => {
  const { currentUser, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  // Close menu on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    if (open) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  if (!currentUser || currentUser.isAnonymous) return null;

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={() => setOpen((v) => !v)}
        className={`flex items-center justify-center w-10 h-10 rounded-full font-bold text-white focus:outline-none focus:ring-2 focus:ring-blue-400 transition-all duration-200 ${
          isDarkMode ? "bg-blue-600" : "bg-blue-500"
        }`}
        title={currentUser.email}
      >
        {currentUser.email?.[0]?.toUpperCase() || "U"}
      </button>
      {open && (
        <div
          className={`absolute right-0 mt-2 w-64 rounded-xl shadow-xl z-50 border text-sm ${
            isDarkMode
              ? "bg-[#181c20] border-gray-700 text-white"
              : "bg-white border-gray-200 text-gray-900"
          }`}
        >
          <div className="px-5 py-4 border-b text-base font-medium truncate flex items-center gap-2" style={{borderColor: isDarkMode ? '#2a2e33' : '#eee'}}>
            <i className="fas fa-user text-base" />
            {currentUser.email}
          </div>
          <ul className="py-1">
            {/* <li className="px-5 py-3 hover:bg-blue-100 cursor-pointer transition-colors">Upgrade plan</li>
            <li className="px-5 py-3 hover:bg-blue-100 cursor-pointer transition-colors">Customize BlippAI</li>
            <li className="px-5 py-3 hover:bg-blue-100 cursor-pointer transition-colors">Settings</li>
            <li className="px-5 py-3 hover:bg-blue-100 cursor-pointer transition-colors">Help</li> */}
            <li>
              <button
                onClick={logout}
                className="w-full text-left px-5 py-3 text-red-500 hover:bg-red-100 font-semibold cursor-pointer transition-colors"
              >
                Log out
              </button>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default UserMenu; 